import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";

const BRAND_KEYS = ["brand", "brands"];

export const useViewBrandQuery = ({ page, limit, q } = {}) => {
  const isPaginated = page !== undefined && limit !== undefined;
  const trimmedQ = q?.trim?.() ?? "";

  return useQuery({
    queryKey: isPaginated
      ? ["viewBrand", page, limit, trimmedQ]
      : ["viewBrand"],
    queryFn: async () => {
      const params = {};
      if (isPaginated) {
        params.page = page;
        params.limit = limit;
        if (trimmedQ) params.q = trimmedQ;
      }

      const res = await api.get("/brand/all", { params });

      if (isPaginated) {
        const parsed = parsePaginatedResponse(res.data, BRAND_KEYS, limit);
        return {
          brands: parsed.items,
          pagination: parsed.pagination,
        };
      }

      return res.data;
    },
    placeholderData: isPaginated
      ? (previousData) => previousData
      : undefined,
    staleTime: isPaginated ? 60_000 : undefined,
  });
};
